import { RemoteStack } from "../../../../data/usecases/stack/remote-stack";
import { Stack } from "../../../../domain/models/stacks";
import { settings } from "../../../configs/settings";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteStack = (): Stack =>
  new RemoteStack(
    "/stacks/public/all",
    makeAxiosHttpClient(),
    settings.API_URL
  );
